import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import $ from "jquery";
import { ethers } from "ethers";
import { toast } from "react-toastify";
const { createAlchemyWeb3 } = require("@alch/alchemy-web3");
const web3 = createAlchemyWeb3(
  "wss://eth-mainnet.g.alchemy.com/v2/wa06SAgkK-JnXxCV_W7SaV2wRrk6sV8z"
);
// const web3 = createAlchemyWeb3(
//   "wss://eth-sepolia.g.alchemy.com/v2/cNqlTGj0djoiN1nQwj46ia9oA4Nb9hvU"
// );

const contractABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_mintAmount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxMintAmountPerTx",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxMintPerWallet",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "walletOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const contractAddress = "0xce3800AB3AfDA8cB4a7D4A25F3517c7E0EE1B931";
const contractInstance = new web3.eth.Contract(contractABI, contractAddress);

function MintPage() {
  const [errorMessage, setErrorMessage] = useState(null);
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [connButtonText, setConnButtonText] = useState("Connect Wallet");
  const [count, setCount] = useState(1);
  const [mintCost, setMintCost] = useState(0);
  const [totalSupply, setTotalSupply] = useState(1000);
  const [totalMinted, setTotalMinted] = useState(0);

  async function mintNFT() {
    if ((!(window.ethereum && window.ethereum.isMetaMask) || (window.ethereum.selectedAddress === "0x0000000000000000000000000000000000000000" || !window.ethereum.selectedAddress))) {
      toast.error("Please connect your wallet first to mint NFTs");
      return;
    }

    const loadingToast = toast.loading("Minting in progress...");

    const gasAmount = await contractInstance.methods
      .mint(count)
      .estimateGas({
        from: window.ethereum.selectedAddress,
        value: mintCost * (count * 10 ** 18),
      })
      .catch((error) => {
        console.log(error.message);
        if (
          error.message ===
          "Returned error: execution reverted: Unable to mint that many NFTs!"
        ) {
          toast.dismiss(loadingToast);
          toast.error("Unable to mint more than 5 NFTs total.");
          return;
        }
        error.message =
          "There was an error minting your NFT. Please try again.";
        toast.dismiss(loadingToast);
        toast.error(error.message);
        return;
      });
    console.log(gasAmount);
    if (!gasAmount) return;
    const gasPrice = await web3.eth.getGasPrice();

    contractInstance.methods
      .mint(count)
      .send({
        to: contractAddress, // Required except during contract publications.
        from: window.ethereum.selectedAddress, // must match user's active address.
        value: mintCost * (count * 10 ** 18),
        gas: Math.floor(gasAmount * 1.2),
        gasPrice: Math.floor(gasPrice * 1.2),
      })
      .then(() => {
        toast.dismiss(loadingToast);
        toast.success(`${count} NFTs minted successfully`);
      })
      .catch((error) => {
        console.log(error.message);
        if (
          error.message ===
          "MetaMask Tx Signature: User denied transaction signature."
        ) {
          toast.dismiss(loadingToast);
          toast.error("You rejected the transaction.");
          return;
        }
        error.message =
          "There was an error minting your NFT. Please try again.";
        toast.dismiss(loadingToast);
        toast.error(error.message);
      });
  }

  // useEffect(() => {
  //   contractInstance.methods
  //     .totalSupply()
  //     .call()
  //     .then(function (_supply) {
  //       $(".total-mints").text(_supply);
  //     });
  // }, []);

  // update account, will cause component re-render
  const accountChangedHandler = (newAccount) => {
    setDefaultAccount(newAccount);
    getAccountBalance(newAccount.toString());
  };

  const getAccountBalance = (account) => {
    window.ethereum
      .request({ method: "eth_getBalance", params: [account, "latest"] })
      .then((balance) => {
        setUserBalance(ethers.utils.formatEther(balance));
      })
      .catch((error) => {
        setErrorMessage(error.message);
      });
  };

  const chainChangedHandler = () => {
    window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }],
    });
  };

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", accountChangedHandler);
      window.ethereum.on("chainChanged", chainChangedHandler);
    }
  }, []);

  //increment decmrent by 0.15
  const increment = () => {
    if (count < 5) {
      setCount(count + 1);
    }
  };

  const decrement = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  return (
    <>
      <section className="">
        <h1 className="text-center mt-5">MINTING</h1>
        <div
          className="text-white box__1"
          style={{
            border: "1px solid #fff",
          }}
        >
          <h3 className="m-0">BULLS BULLS BULLS</h3>
          <p className="m-0 text-white">
            FREE MINT
          </p>
          <div className="input__div">
            <button onClick={decrement} className="minus">
              -
            </button>
            <input
              disabled={true}
              className="nft-num"
              placeholder="0"
              readyonly="true"
              value={count}
              onChange={(e) => setCount(e.target.value)}
              type="text"
            />
            <button onClick={increment} className="plus">
              +
            </button>
          </div>
          <button onClick={mintNFT} className="mint__btn">
            Mint Now
            {/* {connButtonText} */}
          </button>
        </div>
      </section>
      <p
        className="text-center text-white"
        style={{
          fontSize: "1.75rem",
          fontWeight: "bold",
          marginTop: "1rem",
          marginBottom: "7rem",
        }}
      >
        Bullish NFTs. 1,000 unique designs. Own your legend.
      </p>
      <div className="p-md-5 px-5">
        <div className="row row_imges">
          <div className="col">
            <img className="w-100 " src="/Assets/1.png" alt="" />
          </div>
          <div className="col">
            <img className="w-100 img__style21" src="/Assets/2.png" alt="" />
          </div>
          <div className="col">
            <img className="w-100 " src="/Assets/3.png" alt="" />
          </div>
          <div className="col">
            <img className="w-100 img__style21" src="/Assets/4.png" alt="" />
          </div>
          <div className="col">
            <img className="w-100 " src="/Assets/5.png" alt="" />
          </div>
        </div>
      </div>
    </>
  );
}

export default MintPage;
